export default function ProgressBar({ step, total }: { step: number; total: number }){
  const pct = Math.min(100, Math.round((step/total)*100));
  return (
    <div className="progress" aria-label="progress">
      <span style={{ width: `${pct}%` }} />
    </div>
  );
}
